import { FORMAT_DATE_SMALL } from "@/utils/common/date";
import { getPageData } from "@/graphql/page.gql";
import { queryK2PriceActivity } from "@/graphql/promotion.gql";
import { getPromotionStatus, sortPromotionList } from "@/utils/promotion";
import { handlePaginationData, queryRequest } from "@/utils/request";
export default {
  namespaced: true,
  state: {
    promotionData: []
  },
  mutations: {
    savePromotionDataMutation(state, data) {
      state.promotionData = data || [];
    }
  },
  actions: {
    async getPromotionData({ commit }) {
      const { data: list } = handlePaginationData(
        await queryRequest({
          query: queryK2PriceActivity,
          variables: { pageInput: { pageSize: 1000, pageNum: 1 } } // pageSize = 1000 => 接口暂无状态排序，需手动排序
        })
      );
      commit(
        "savePromotionDataMutation",
        sortPromotionList(
          (list || []).map(item => {
            // 添加活动状态
            item._promotionStatus = getPromotionStatus(
              item.countDownStart,
              item.countDownEnd,
              FORMAT_DATE_SMALL
            );
            return item;
          }),
          FORMAT_DATE_SMALL
        ).slice(0, 3) // 只展示三个
      );
    },
    async getPageData(context, data: any) {
      let { content, pageTitle } = await queryRequest({
        query: getPageData,
        variables: {
          getPageByUrlInput: {
            ...data,
            deviceType: "H5"
          }
        }
      });
      return { content: JSON.parse(content || "[]"), pageTitle };
    }
  }
};
